const department = 'department'
const guest = 'guest'
const teamMember = 'teamMember'
const welcomeMenu = 'welcomeMenu'
const ringGroup = 'ringGroup'
const callQueues = 'callQueues'

const contacts = {
  default: guest,
  colorMap: {
    [department]: 'primaryDark1',
    [guest]: 'grayDark3',
    [teamMember]: 'secondary',
    [welcomeMenu]: 'primary',
    [ringGroup]: 'primaryLight1',
    [callQueues]: 'secondaryLight2',
  },
  list: [guest, teamMember, department, welcomeMenu, ringGroup, callQueues], // order matters standard first
  names: {
    department,
    guest,
    teamMember,
    welcomeMenu,
    ringGroup,
    callQueues,
  },
  display: {
    all: 'all',
    single: 'single',
    headers: 'headers',
  },
}

export const DIRECT_CALL = 'direct'
export const CONTACTS_MAP = {
  department,
  guest,
  teamMember,
  welcomeMenu,
  ringGroup,
  callQueues,
}

// TODO move to flatter structure
export const GUEST = guest

export default contacts
